import { deserialize, serialize } from "serializr";
import { FunctionBody } from "typescript";
import axiosInstance from "../../../interceptor/axiosInstance";
import {
  ExamExerciseQuestionModel,
} from "../../../models/ExamModels/ExerciseModel/question.model";
import QuestionModel from "../../../models/ExerciseModal/Question.model";
import {
  EXAM_SUBJECT_CHAPTERS_EXERCISES_QUESTION,
  QUESTION_ATTACHMENTS,
} from "../../../routes/routeConstants/apiRoutes";
import Notification from "../../../shared/components/Notification";
import { NotificationTypes } from "../../../enums/notificationTypes";

export class ExamExerciseQuestionService {
  static createExamExerciseQuestion(
    data: any,
    onSuccess: (question: ExamExerciseQuestionModel) => void,
    onError: Function,
    onFinal: () => void
  ) {
    const serializeData = serialize(ExamExerciseQuestionModel, data);
    const payload = { exam_question: serializeData };
    return axiosInstance
      .post(EXAM_SUBJECT_CHAPTERS_EXERCISES_QUESTION, payload)
      .then((response) => {
        const question = deserialize(
          ExamExerciseQuestionModel,
          response["data"]?.exam.exam_exercise_question
        );
        onSuccess(question);
      })
      .catch((error) => {
        onError(error);
      })
      .finally(() => {
        onFinal();
      });
  }

  static updateExamExerciseQuestion(
    id: any,
    data: any,
    onSuccess: (question: ExamExerciseQuestionModel) => void,
    onError: Function,
    onFinal: () => void
  ) {
    const serializeData = serialize(ExamExerciseQuestionModel, data);
    const payload = { exam_question: serializeData };
    return axiosInstance
      .put(EXAM_SUBJECT_CHAPTERS_EXERCISES_QUESTION + `/${id}`, payload)
      .then((response) => {
        const question = deserialize(
          ExamExerciseQuestionModel,
          response["data"]?.exam.exam_exercise_question
        );
        onSuccess(question);
      })
      .catch((error) => {
        onError(error);
      })
      .finally(() => {
        onFinal();
      });
  }

  static deleteExamExerciseQuestion(
    id: any,
    onSuccess: Function,
    onError: Function
  ) {
    return axiosInstance
      .delete(EXAM_SUBJECT_CHAPTERS_EXERCISES_QUESTION + `/${id}`)
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        onError(error);
      });
  }
  static getQuestionsbyExerciseId(id: any, onSuccess: any, onError: Function) {
    return axiosInstance
      .get(EXAM_SUBJECT_CHAPTERS_EXERCISES_QUESTION, {
        params: {
          exam_exercise_id: id,
          search: "",
        },
      })
      .then((response) => {
        console.log(response);
        const questions = deserialize(
          ExamExerciseQuestionModel,
          response["data"]["exam_questions"]
        );
        onSuccess(questions);
      })
      .catch((error) => {
        onError(error);
      });
  }

}
